// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8ffab79","239":"2efd757c","488":"11ec364a","667":"e1fa246f"}[chunkId] + ".chunk.js";
};